<div class="row">
  <div *ngFor="let item of items" class="col-6 col-md-4 col-lg-3 mb-3">
    <ng-template libCustomHost></ng-template>
  </div>
</div>
